<template>
    <div class="box"> 
      <div class="newsviews">
        <div class="tab">
          <router-link to="/">首页</router-link>>联系我们
        </div>
        <div class="views">
          <div class="leftdiv">
            <h1>留言咨询</h1>
            <div class="inputarea">
                <input class="inname" type="text" v-model="form.name" placeholder="您的姓名"/>
                <input class="innum" type="text" v-model="form.phone" placeholder="您的联系方式"/>
                <textarea class="incontent" v-model="form.content" cols="25" rows="5" placeholder="请留下您需要咨询的内容..."></textarea>
            </div>
            <button class="btncommit" @click="submitForm()">提交</button>
          </div>
          <div class="rightdiv">
            <h1>联系我们</h1>
            <div class="infoarea">
                <p>电话：<span>{{ phone }}</span></p>
                <p>网址：<span>www.cnzhw.org.cn</span></p>
                <p>E-Mail：<span>{{ email }}</span></p>
                <p>公司地址：<span>{{ address }}</span></p>
                <div class="hengx">
                </div>
                <p style="font-size:18px">{{copyright}}</p>
                <p style="font-size:18px">{{recodenum}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
  
<script>
  import { IP_TEST } from '@/config'
  import { leaveMessages } from '@/request/sacinfo'
  export default {
    name: "ConcantUs",
    components: {
    },
    computed: {
        copyright() {
        return this.$store.getters.copyright;
        },
        recodenum() {
        return this.$store.getters.recodenum;
        },
        address() {
        return this.$store.getters.address;
        },
        email() {
        return this.$store.getters.email;
        },
        name() {
        return this.$store.getters.name;
        },
        phone() {
        return this.$store.getters.phone;
        },
        mobile() {
        return this.$store.getters.mobile;
        },
        shortname() {
        return this.$store.getters.shortname;
        },
    },
    data() {
      return {
        form: {
        name: '',
        phone: '',
        content: ''
      },
        IP_TEST: IP_TEST
      }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        submitForm() {
            if (this.form.name.length > 10) {
                this.$message.error("称呼不能超过10个字");
                return;
            }
            if (!/^\d{7,11}/.test(this.form.phone)) {
                this.$message.error("请输入正确的联系方式");
                return;
            }
            console.log(this.form.content);
            if (!this.form.content) {
                this.$message.error("请输入留言内容");
                return;
            }
            leaveMessages(this.form).then(() => {
                this.form = {};
                this.$message.success({ message: "留言成功", offset: 100 });
            });
            },
    }
  };
</script>
<style scoped>
  .box{
    position: relative;
    width: 100%;
    margin: 0 auto;
    /* background-color: #fff; */
  }
  .newsviews{
    position: relative;
    width: 1300px;
    /* min-height: 1166px; */
    margin: 0 auto;
    overflow: hidden;
  }
  .newsviews .tab{
    margin: 16px 0 16px 0;
    width: 324px;
    height: 14px;
    font-weight: 500;
    font-size: 14px;
    font-weight: 400;
    color: #D9D9D9;
    line-height: 16px;
  }
  .newsviews .tab a{
    color: #D9D9D9;
  }
  .newsviews .views{
    min-height: 548px;;
    padding: 27px;
    background-image: url(/static/img/Subtract.png);
    background-repeat: no-repeat;
    background-size: contain;
  }
  .leftdiv{
    width:623px;
    height: 445px;
    border-right: 1px solid #999999;
    display: inline-block;
}
 .inputarea{
    width:521px;
    margin:auto;
    margin-top: 38px;
    /* height:272px; */
}
.infoarea{
    width:569px;
    /* margin:auto; */
    margin-left: 46px;
    margin-top: 38px;
}
.leftdiv h1{
    text-align: center;
    font-weight: 400;
color: #000000;
}
.leftdiv .inname{
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    line-height: 15px;
    padding: 15px;
    width: 162px;
    height: 15px;
    background: #F5F5F5;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid #D9D9D9;
}
.leftdiv .innum{
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    line-height: 15px;
    padding: 15px;
    width:  267px;
    height: 15px;
    background: #F5F5F5;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid #D9D9D9;
    margin-left: 13px;
}
.leftdiv .incontent{
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    line-height: 19px;
    padding: 17px;
    width: 470px;
    height: 197px;
    background: #F5F5F5;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid #D9D9D9;
    margin-top:17px ;
    overflow:hidden;
    /* margin-left: 13px; */
}
.leftdiv .btncommit{
    width: 247px;
height: 45px;
background: #2E8EEB;
border-radius: 8px 8px 8px 8px;
opacity: 1;
font-size: 20px;
font-weight: normal;
color: #FFFFFF;
line-height: 23px;
margin: auto;
margin-top:35px ;
display: block;
/* text-align: center; */
}
  .rightdiv{
    width:618px;
    display: inline-block;
    position: absolute;
}
.rightdiv h1{
    text-align: center;
    font-weight: 400;
color: #000000;
}
.infoarea p{
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 45px;

}
.hengx{
    border: solid 1px #D9D9D9;
    margin: 30px 0px;
}
</style>
  